/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm, change } from 'redux-form';
import Select, { components } from 'react-select';
import moment from 'moment';

import { Preloader } from '../preloader';
import FixRequiredSelect from '../../helpers/fixReactSelect';
import { ReactComponent as ArrowIcon } from '../../assets/arrow.svg';
import { getNearTicketsAction } from './actions';
import {
    switchPopupCreateAction,
    setCreatingWriteAction
} from '../schedule/actions';
import { API_SERVER } from '../../constans/api';
import './style.scss';

const DropdownIndicator = props => (
    <components.DropdownIndicator {...props}>
        <ArrowIcon />
    </components.DropdownIndicator>
);

const SelectInput = ({ options, input, placeholder }, ...props) => (
    <FixRequiredSelect
        {...props}
        SelectComponent={Select}
        options={options}
        value={input.value}
        onChange={value => input.onChange(value)}
        onBlur={value => input.onBlur(value.value)}
        components={{ DropdownIndicator }}
        classNamePrefix="select-input"
        placeholder={placeholder}
        required
    />
);

class NearForm extends React.Component {
    state = {
        selectedServiceID: null
    }

    createPopupWrite = (ticket) => {
        const { dispatch } = this.props;

        dispatch(setCreatingWriteAction('SET', ticket));
        dispatch(switchPopupCreateAction());
    }

    onChange = (value) => {
        const { dispatch } = this.props;
        this.setState({ selectedServiceID: +value.value });
        dispatch(getNearTicketsAction(value.value));
    }

    filterNearestTickets = (data) => {
        let nearestTickets = {};

        data[0].tickets.forEach((day) => {
            nearestTickets = {
                ...nearestTickets,
                [day.date]: []
            };
        });

        data.forEach(doctor => (
            doctor.tickets.forEach((day) => {
                const date = moment(day.date);
                const isToday = moment().format('DD.MM.YYYY') === date.format('DD.MM.YYYY');
                const isTomorrow = moment().add(1, 'day').format('DD.MM.YYYY') === date.format('DD.MM.YYYY');
                let labelDate = date.format('dddd');

                if (isToday) labelDate = 'Сегодня';
                if (isTomorrow) labelDate = 'Завтра';

                const tickets = day.data.length ? day.data : null;

                if (tickets) {
                    nearestTickets = {
                        ...nearestTickets,
                        [day.date]: [...nearestTickets[day.date], {
                            doctor,
                            tickets,
                            labelDate
                        }]
                    };
                }
            })
        ));

        const countNearestTickets = Object.keys(nearestTickets).filter(dateKey => (nearestTickets[dateKey].length));

        return countNearestTickets.length ? nearestTickets : null;
    }

    render() {
        const { schedule, nearTickets } = this.props;
        const { selectedServiceID } = this.state;
        const { services } = schedule;
        const SERVICES = services && services.length ? services.map(item => ({ label: item.name, value: item.id })) : [];
        const nearestTickets = nearTickets.data && nearTickets.data.length ? this.filterNearestTickets(nearTickets.data) : null;
        const maxTickets = 3;
        let showTickets = 0;

        return (
            <form className="schedule__popup__form">
                <div className="schedule__popup__form_field">
                    <label>
                        <span>*</span>
                        &nbsp;
                        Выберите услугу:
                    </label>
                    <br />
                    <Field name="service-type" component={SelectInput} onChange={this.onChange} placeholder="Выберите вариант" options={SERVICES} />
                </div>
                <div className="near-tickets__doctors">
                    {nearestTickets && Object.keys(nearestTickets).map((dateKey) => {
                        const date = moment(+dateKey);
                        const doctors = nearestTickets[dateKey];

                        return doctors.map((item) => {
                            const { tickets, doctor, labelDate } = item;

                            if (tickets) {
                                showTickets++;
                                if (showTickets > maxTickets) return null;
                                return (
                                    <div className="near-tickets__doctors__item" key={`doctor-id-${doctor.id}`}>
                                        <span className="near-tickets__doctors__item_date">{`${labelDate}, ${moment(date).format('DD.MM')}`}</span>
                                        <div className="near-tickets__doctors__item_photo" style={{ backgroundImage: `url('${API_SERVER}${doctor.photo}')` }} />
                                        <span className="near-tickets__doctors__item_name">
                                            {doctor.last_name}
                                            <br />
                                            {doctor.first_name}
                                        </span>
                                        <div className="near-tickets__doctors__item__tickets">
                                            <div className="near-tickets__doctors__item__tickets_item">
                                                <button type="button" className="ticket" onClick={() => this.createPopupWrite(tickets[0])}>
                                                    {`${moment(tickets[0].time_start).format('HH:mm')} - ${moment(tickets[0].time_end).format('HH:mm')}`}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                );
                            }
                            return null;
                        });
                    })}
                </div>
                {nearestTickets === null && selectedServiceID !== null ? <p className="near-tickets_empty">~ Нет ближайших талонов ~</p> : null}
                {nearTickets.loading ? <Preloader /> : null}
            </form>
        );
    }
}

SelectInput.defaultProps = {
    placeholder: ''
};

SelectInput.propTypes = {
    input: PropTypes.object.isRequired,
    options: PropTypes.array.isRequired,
    placeholder: PropTypes.string
};


NearForm.propTypes = {
    dispatch: PropTypes.func.isRequired,
    schedule: PropTypes.object.isRequired,
    nearTickets: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    schedule: state.schedule,
    nearTickets: state.nearTickets
});

const wrapper = compose(
    connect(mapStateToProps),
    reduxForm({ form: 'nearForm' })
);


export default wrapper(NearForm);
